import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AppConfigService } from 'services/app-config.service';
import { map } from 'rxjs/operators';

export const BlockingHistoryGuard: CanActivateFn = () => {
  const appConfigService = inject(AppConfigService);

  return appConfigService
    .childFeaturesEnabled$()
    .pipe(
      map((childFeaturesEnabled) =>
        appConfigService.routeEnabled('blocking-history', childFeaturesEnabled)
      )
    );
};
